<template>
  	<div class="rightBlock shareGameTabC">
		<link v-bind:href="dynamicCssPath" rel="stylesheet" type="text/css">
		<el-container>
			<el-main>
				<div class="tab" style="display: block;">
          <child-productbuttonc  ref="childProductButtonc"></child-productbuttonc>

          <el-dialog :title="$t('advancedTab.dks')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogDKSVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-dksC :key="componentKey" ref="childdksc"></child-dksC>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogDKSVisible = false">{{$t("shareGameTab.cancelInfo")}}</el-button>
          </div>
          </el-dialog>

          <el-dialog :title="$t('advancedTab.mt')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogMTVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-mtC :key="componentKey" ref="childmtc"></child-mtC>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogMTVisible = false">{{$t("shareGameTab.cancelInfo")}}</el-button>
          </div>
          </el-dialog>


          <el-dialog :title="$t('advancedTab.tgl')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogTGLVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-tglC :key="componentKey" ref="childtglc"></child-tglC>

            <div slot="footer" class="dialog-footer">
            <el-button @click="dialogTGLVisible = false">{{$t("shareGameTab.cancelInfo")}}</el-button>
            </div>
          </el-dialog>

          <el-dialog :title="$t('advancedTab.mpt')" 
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogMPTVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-mptC :key="componentKey" ref="childmptc"></child-mptC>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogMPTVisible = false">{{$t("shareGameTab.cancelInfo")}}</el-button>
          </div>
          </el-dialog>


          <el-dialog :title="$t('advancedTab.end')"
          width="60%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogENDVisible">
          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-end :key="componentKey" ref="childendc"></child-end>

          <div slot="footer" class="dialog-footer">
          <el-button @click="dialogENDVisible = false">{{$t("shareGameTab.cancelInfo")}}</el-button>
          </div>
          </el-dialog>


					<div class="channel">

            <div tip>{{$t("shareGameTab.tip")}}</div>
						<el-tabs ref="tabs" v-model="tabName"  @tab-click="handleTabClick">

							<el-tab-pane :label="$t('shareGameTab.valorant')" name="valorant">
                <el-empty v-if="myfuns.length == 0" :description="$t('shareGameTab.emptyInfo')"></el-empty>
                <ul class="functions scroll" v-if="myfuns.length > 0">

                  <li :style="getIconTypePath('REST','')"
                      data-type="REST"
                      data-name="REST"
                      data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>

                  <li v-for="item in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span></li>
                </ul>
							</el-tab-pane>

              <!-- <el-tab-pane :label="$t('shareGameTab.csgo')" name="csgo">
                <el-empty v-if="myfuns.length == 0" :description="$t('shareGameTab.emptyInfo')"></el-empty>
                <ul class="functions scroll" v-if="myfuns.length > 0">

                  <li :style="getIconTypePath('REST','')"
                      data-type="REST"
                      data-name="REST"
                      data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>

                  <li v-for="item in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span></li>
                </ul>
							</el-tab-pane>

              <el-tab-pane :label="$t('shareGameTab.cf')" name="cf">
                <el-empty v-if="myfuns.length == 0" :description="$t('shareGameTab.emptyInfo')"></el-empty>
                <ul class="functions scroll" v-if="myfuns.length > 0">

                  <li :style="getIconTypePath('REST','')"
                      data-type="REST"
                      data-name="REST"
                      data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>

                  <li v-for="item in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span></li>
                </ul>
							</el-tab-pane>

              <el-tab-pane :label="$t('shareGameTab.qy')" name="qy">
                <el-empty v-if="myfuns.length == 0" :description="$t('shareGameTab.emptyInfo')"></el-empty>
                <ul class="functions scroll" v-if="myfuns.length > 0">

                  <li :style="getIconTypePath('REST','')"
                      data-type="REST"
                      data-name="REST"
                      data-task="REST"
                  ><span>{{$t("advancedTab.rest")}}</span></li>

                  <li v-for="item in myfuns"
                    :style="getIconTypePath(item.type,item.icon)"
                    :data-type="item.type"   
                    :data-name="item.name" 
                    :data-task="item.content"
                  ><span>{{showCommandName(item)}}</span></li>
                </ul>
							</el-tab-pane> -->


						</el-tabs>						
					</div>
				</div>
			</el-main>
		</el-container>
	</div>
</template>
<script>
import $ from 'jquery'


import valorant from '../../../../theme/game/valorant.json';

import KeyboardMapConf from '../../../../theme/keyboard.map.json';
import cmd10 from '../../../../theme/cmd1.0.config.json';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../../../asserts/js/hid_device.js';
// 命令数据功能操作对象
import { CommandHandle } from '../../../../utils/command_handle.js';

import productButtonC from './productButton.vue'
import buttonPaneC from './buttonTabPane/buttonPaneC.vue'

import dksC from '../../../../components/box/dks.vue'
import mtC from '../../../../components/box/mt.vue'
import tglC from '../../../../components/box/tgl.vue'
import mptC from '../../../../components/box/mpt.vue'
import endC from '../../../../components/box/end.vue'

export default {
  name: 'shareGameTabC',
  components: 
  {
      'child-productbuttonc':productButtonC,
	    buttonPaneC,
      'child-dksC':dksC,
      'child-mtC':mtC,
      'child-tglC':tglC,
      'child-mptC':mptC,
      'child-end':endC,
  },
  data() {

    return {
	    HIDDeviceObj:null,
      tabName: 'valorant',
      msg:"",
      msgShow:false,
      myfuns:[],

      dragging: false,
      mouseX: 0,
      mouseY: 0,
      initialX: 0,
      initialY: 0,
      offsetX: 0,
      offsetY: 0,

      dialogDKSVisible:false,
      dialogMTVisible:false,
      dialogTGLVisible:false,
      dialogMPTVisible:false,
      dialogENDVisible:false,

    }
  },
  mounted() 
  {
    this.myfuns = valorant;
    this.JQSet();
    this.$refs.tabs.$el.querySelector(".el-tabs__active-bar").style.width = "70px";
  },
  methods: 
  {
    //刷新自定义命令数据
    init()
    {
      const ChildProductBottonC = this.$refs.childProductButtonc;
            ChildProductBottonC.KeyMap = this.HIDDeviceObj.MatrixList.KeyMap;
            ChildProductBottonC.HIDDeviceObj = this.HIDDeviceObj;
            ChildProductBottonC.setProductImagePath();
    },
    JQSet()
    {
      var context = this;
      //JQ操作
      $(function() 
      {   
          $(".shareGameTabC .functions").on("contextmenu","li",function()
            {
                var md5 = $(this).attr("data-md5");
                var name = $(this).attr("data-name");
                var task = $(this).attr("data-task");
                var type = $(this).attr("data-type");

                //功能编辑页面
                context.enterEditPage(type,md5,name,task);
            });
          //多功能功能键设置
          $(".shareGameTabC .functions").on("click","li",function()
          {
              var md5 = $(this).attr("data-md5");
              var name = $(this).attr("data-name");
              var task = $(this).attr("data-task");
              var type = $(this).attr("data-type");

              var button = $(".shareGameTabC .buttons li.on");
              if(button.length == 0)
              {
                if(name == "REST")
                {
                  context.$message({message:context.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
                  return false;
                }

                context.$confirm(context.$i18n.t("msg.commandSelectWarnView"), context.$i18n.t("msg.confirmTitCommand"), 
                {
                  confirmButtonText:  context.$i18n.t("msg.confirmOKCommandView"),
                  cancelButtonText: context.$i18n.t("msg.confirmNoCommand"),
                  type: 'warning'
                }).then(() => 
                {
                  //功能编辑页面
                  context.enterEditPage(type,md5,name,task);

                }).catch(() => {});

                return false;
              }

              //功能设置开始
              switch(type)
              {
                case "REST":
                {
                    var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,button.attr("name"));
                    //恢复高级功能
                    cmd10.SET_DEVICE_BUTTON_DEL_CMD[5] = buttonObj.Hid;
                    const outputReportData1 = new Uint8Array(cmd10.SET_DEVICE_BUTTON_DEL_CMD.map(hex => parseInt(hex, 16)));
                    context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData1);

                    //刷新UI
                    context.refreshKeyData(button.attr("name"),"","");

                }break;
              }
              
          });
      });

    },
    //获取图标
    getIconPath(name)
    {
        let imgUrl = require("../../../../asserts/image/command_icon/" + name);   
        
        return '--bgurl: url(' + imgUrl + ')';
    },
    //获取TYPE图标
    getIconTypePath(name,icon)
    {
        let imgUrl = require("../../../../asserts/image/tools/" + name + ".png");   
        
        return '--bgurl: url(' + imgUrl + ')';
    },
    //显示命令名称
    showCommandName(item)
    {
        if(item.type == 'HOTKEY')
        {
          return item.name == ''?item.content:item.name;
        }
        else
        {
          return item.name == ''?item.type:item.name;
        }
    },
    //刷新按键自定义数据
    refreshKeyData(keyName,type,custom)
    {
        let mapData = this.HIDDeviceObj.MatrixList.KeyMap;
        //组装矩阵数据
        for(let i=0;i<mapData.length;i++)
        {
          for(let j=0;j<mapData[i].length;j++)
          {
              let bottonObj = mapData[i][j];
              let keyNameFromMap = bottonObj.key_name;
              if(keyName == 0)
                  continue;

              if(keyName == keyNameFromMap)
              {
                  mapData[i][j].custom.type = type;
                  mapData[i][j].custom.name = custom;
                  mapData[i][j].custom.content = custom;
              }
          }
        }

        //刷新数据
        const ProductButtonC = this.$refs.childProductButtonc;
              ProductButtonC.KeyMap = mapData;
        
        this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});

    },
    //刷新命令数据
    refreshData(type)
    {
      if(type == "valorant")
      {
        this.myfuns = valorant;
        // this.JQSet();
      }
      else
      {
        this.myfuns = [];
      }
    },
    handleTabClick(tab, event) 
    { 
      let tabName = tab.name;
      this.refreshData(tabName);
    },
    handleTools(type)
    {
        switch(type)
        { 
          case  "tools":
          {
            this.dialogToolsVisible = true;
          }break;
          case  "macro":
          {
            this.dialogMacroVisible = true;
          }break;
          case  "dks":
          {
            this.dialogDKSVisible = true;
          }break;
          case  "mt":
          {
            this.dialogMTVisible = true;
          }break;
          case  "tgl":
          {
            this.dialogTGLVisible = true;
          }break;
          case  "mpt":
          {
            this.dialogMPTVisible = true;
          }break;
          case  "end":
          {
            this.dialogENDVisible = true;
          }break;
        }
    },
    
    //功能编辑页面
    enterEditPage(type,md5,name,task)
    {
        var context = this;
        switch(type)
        {
          case "DKS":
          {
            context.dialogDKSVisible = true;
            setTimeout(()=>
            {
              const ChildDKSC = context.$refs.childdksc;
                    ChildDKSC.editFunc(md5,name,task);  
            },100);

          }break;
          case "MPT":
          {
            context.dialogMPTVisible = true;
            setTimeout(()=>
            {
              const ChildMPTC = context.$refs.childmptc;
                    ChildMPTC.editFunc(md5,name,task); 
            },100);

          }break;
          case "MT":
          {
            context.dialogMTVisible = true;
            setTimeout(()=>
            {
              const ChildMTC = context.$refs.childmtc;
                    ChildMTC.editFunc(md5,name,task); 
            },100);

          }break;
          case "END":
          {
            context.dialogENDVisible = true;
            setTimeout(()=>
            {
              const ChildENDC = context.$refs.childendc;
                    ChildENDC.editFunc(md5,name,task); 
            },300);

          }break;
          case "TGL":
          {
            context.dialogTGLVisible = true;
            setTimeout(()=>
            {
              const ChildTGLC = context.$refs.childtglc;
                    ChildTGLC.editFunc(md5,name,task); 
            },100);

          }break;
        }
    },

  },
  computed: 
  {
      dynamicCssPath: function() 
      {
        if(this.activeTab == 'button')
        {
          return 'css/buttonTabPane/button.css'; 
        }
        else if(this.activeTab == 'hotkey')
        {
          return 'css/buttonTabPane/hotkey.css';
        }
        else if(this.activeTab == 'app')
        {
          return 'css/buttonTabPane/app.css';
        }
        else if(this.activeTab == 'macro')
        {
          return 'css/buttonTabPane/macro.css';
        }
        else if(this.activeTab == 'advanced')
        {
          return 'css/buttonTabPane/advanced.css';
        }

        return 'css/buttonTabPane/button.css'; 
	  }
  }
}

</script>